<template>
	<div class="report_container full">
		<el-container class="full">
			<el-aside width="300px" style="background: rgb(244, 244, 245);">
				<div style="padding: 10px;">
					<v-jstree ref="jstree" text-field-name="name" value-field-name="id" :data="emuntree"
						:collapse="false" @item-click="itemClick" v-if="emuntree.length!=0"></v-jstree>
				</div>
			</el-aside>
			<el-container style="position: relative;">
				<!-- <nb-report ref="nbReport" v-show="reporttype=='nb'" :fundtype="fundtype"  :bancktype="bancktype" /> -->
				<outputinvoice-report ref="outputinvoiceReport" v-if="reporttypes.includes('outputinvoice')"
					v-show="reporttype == 'outputinvoice'" :fundtype="fundtype" :bancktype="bancktype" />
				<inputinvoice-report ref="inputinvoiceReport" v-if="reporttypes.includes('inputinvoice')"
					v-show="reporttype == 'inputinvoice'" :fundtype="fundtype" :bancktype="bancktype" />
				<goodsspu-report ref="goodsspuReport" v-if="reporttypes.includes('goodsspu')"
					v-show="reporttype == 'goodsspu'" :fundtype="fundtype" :bancktype="bancktype" />
					
					
				<pushdatasearchsaleinvbill ref="pushdatasearchsaleinvbill"
					v-if="reporttypes.includes('pushdatasearchsaleinvbill')"
					v-show="reporttype == 'pushdatasearchsaleinvbill'" :fundtype="fundtype" :bancktype="bancktype" />
				<pushdataexchangeonline ref="pushdataexchangeonline"
					v-if="reporttypes.includes('pushdataexchangeonline')"
					v-show="reporttype == 'pushdataexchangeonline'" :fundtype="fundtype" :bancktype="bancktype" />
				<pushdatatradeback ref="pushdatatradeback" v-if="reporttypes.includes('pushdatatradeback')"
					v-show="reporttype == 'pushdatatradeback'" :fundtype="fundtype" :bancktype="bancktype" />
					
					
				<relationcustomer ref="relationcustomer"
					v-if="reporttypes.includes('relationcustomer')"
					v-show="reporttype == 'relationcustomer'" :fundtype="fundtype" :bancktype="bancktype" />
				<relationshop ref="relationshop"
					v-if="reporttypes.includes('relationshop')"
					v-show="reporttype == 'relationshop'" :fundtype="fundtype" :bancktype="bancktype" />
				<relationwarehouse ref="relationwarehouse" v-if="reporttypes.includes('relationwarehouse')"
					v-show="reporttype == 'relationwarehouse'" :fundtype="fundtype" :bancktype="bancktype" />
				<relationdistributorsupplier ref="relationdistributorsupplier" v-if="reporttypes.includes('relationdistributorsupplier')"
					v-show="reporttype == 'relationdistributorsupplier'" :fundtype="fundtype" :bancktype="bancktype" />	
					

				<sourcebill ref="sourcebill" v-if="reporttypes.includes('sourcebill')"
					v-show="reporttype == 'sourcebill'" :fundtype="fundtype" :bancktype="bancktype" />
				<sourcebilldata ref="sourcebilldata" v-if="reporttypes.includes('sourcebilldata')"
					v-show="reporttype == 'sourcebilldata'" :fundtype="fundtype" :bancktype="bancktype" />

				<cd-report ref="cdReport" v-if="reporttypes.includes('cd')" v-show="reporttype == 'cd'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<ct-report ref="ctReport" v-if="reporttypes.includes('ct')" v-show="reporttype == 'ct'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<fk-report ref="fkReport" v-if="reporttypes.includes('fk')" v-show="reporttype == 'fk'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<yfk-report ref="yfkReport" v-if="reporttypes.includes('yfk')" v-show="reporttype == 'yfk'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<fy-report ref="fyReport" v-if="reporttypes.includes('fy')" v-show="reporttype == 'fy'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<ffy-report ref="ffyReport" v-if="reporttypes.includes('ffy')" v-show="reporttype == 'ffy'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<ut-report ref="utReport" v-if="reporttypes.includes('ut')" v-show="reporttype == 'ut'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<fut-report ref="futReport" v-if="reporttypes.includes('fut')" v-show="reporttype == 'fut'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<sk-report ref="skReport" v-if="reporttypes.includes('sk')" v-show="reporttype == 'sk'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<tsk-report ref="tskReport" v-if="reporttypes.includes('tsk')" v-show="reporttype == 'tsk'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<supsk-report ref="supskReport" v-if="reporttypes.includes('supsk')" v-show="reporttype == 'supsk'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<sh-report ref="shReport" v-if="reporttypes.includes('sh')" v-show="reporttype == 'sh'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<other-report ref="otherReport" v-if="reporttypes.includes('other')" v-show="reporttype == 'other'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<check-report ref="checkReport" v-if="reporttypes.includes('check')" v-show="reporttype == 'check'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<import-report ref="importReport" v-if="reporttypes.includes('import')" v-show="reporttype == 'import'"
					:fundtype="fundtype" :bancktype="bancktype" />
				<checkerror-report @changetab="changetab" ref="checkerrorReport"
					v-if="reporttypes.includes('checkerror')" v-show="reporttype == 'checkerror'" :fundtype="fundtype"
					:bancktype="bancktype" />




			</el-container>
		</el-container>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import VJstree from 'vue-jstree'
	// import nbReport from './nbreport.vue'
	import outputinvoiceReport from './outputinvoice.vue'
	import inputinvoiceReport from './inputinvoice.vue'
	import goodsspuReport from './goodsspu.vue'
	import cdReport from './cdreport.vue'
	import ctReport from './ctreport.vue'
	import fkReport from './fkreport.vue'
	import yfkReport from './yfkreport.vue'
	import fyReport from './fyreport.vue'
	import futReport from './futreport.vue'
	import ffyReport from './ffyreport.vue'
	import skReport from './skreport.vue'
	import tskReport from './tskreport.vue'
	import supskReport from './supskreport.vue'
	import shReport from './shreport.vue'
	import utReport from './utreport.vue'
	import otherReport from './otherreport.vue'
	import checkReport from './checkreport.vue'
	import importReport from './importreport.vue'
	import checkerrorReport from './checkerrorreport.vue'

	import pushdatasearchsaleinvbill from './pushdata/searchsaleinvbill/index.vue'
	import pushdataexchangeonline from './pushdata/exchangeonline/index.vue'
	import pushdatatradeback from './pushdata/tradeback/index.vue'
	
	import relationcustomer from './relation/customer/index.vue'
	import relationshop from './relation/shop/index.vue'
	import relationwarehouse from './relation/warehouse/index.vue'
	import relationdistributorsupplier from './relation/distributorsupplier/index.vue'
	
	import sourcebill from './pushdata/sourcebill/sourcebill.vue'
	import sourcebilldata from './pushdata/sourcebill/sourcebilldata.vue'

	export default {
		name: 'report',
		props: {

		},
		data() {
			return {
				reporttypes: ['check'],
				fundtype: 'CHECK',
				bancktype: '',
				reporttype: 'check',
				nodestree: [],
				currentnode: null,
				emuntree: [{
					id: '',
					bancktype: '',
					reporttype: '',
					name: '应用',
					opened: true,
					children: [{
						id: 'CHECK',
						bancktype: '',
						reporttype: 'check',
						name: '对账',
						selected: true
					}, {
						id: '',
						bancktype: '',
						reporttype: '',
						name: '星空',
						opened: true,
						children: [{
								id: 'CHECKERROR',
								bancktype: '',
								reporttype: 'checkerror',
								name: '流水核对',
							}, {
								id: '',
								bancktype: '',
								reporttype: '',
								name: '数据推送',
								opened: true,
								children: [{
									id: '',
									bancktype: '',
									reporttype: '',
									name: '平台原始账单',
									selected: false,
									opened: true,
									children: [{
										id: 'SOURCEBILL',
										bancktype: '',
										reporttype: 'sourcebill',
										name: '分类配置',
									}, {
										id: 'SOURCEBILLDATA',
										bancktype: '',
										reporttype: 'sourcebilldata',
										name: '账单',
									}]
								}, {
									id: '',
									bancktype: '',
									reporttype: '',
									name: '月数据统计',
									selected: false,
									opened: true,
									children: [{
										id: 'PUSHDATASEARCHSALEINVBILL',
										bancktype: '',
										reporttype: 'pushdatasearchsaleinvbill',
										name: '销售出库单',
										selected: false,
									}, {
										id: 'PUSHDATAEXCHANGEONLINE',
										bancktype: '',
										reporttype: 'pushdataexchangeonline',
										name: '线上售后单',
										selected: false,
									}, {
										id: 'PUSHDATATRADEBACK',
										bancktype: '',
										reporttype: 'pushdatatradeback',
										name: '销售退货入库',
										selected: false,
									}]
								}]
							},
							{
								id: '',
								bancktype: '',
								reporttype: '',
								name: '对应关系',
								children: [{
									id: 'RELATIONSHOP',
									bancktype: '',
									reporttype: 'relationshop',
									name: '店铺',
									selected: false,
								}, 
								{
									id: 'RELATIONWAREHOUSE',
									bancktype: '',
									reporttype: 'relationwarehouse',
									name: '仓库',
									selected: false,
								},{
									id: 'RELATIONCUSTOMER',
									bancktype: '',
									reporttype: 'relationcustomer',
									name: '客户',
									selected: false,
								},{
									id: 'RELATIONDISTRIBUTORSUPPLIER',
									bancktype: '',
									reporttype: 'relationdistributorsupplier',
									name: '分销供应商',
									selected: false,
								}]
							},
						]
					}]
				}, {
					id: '',
					bancktype: '',
					reporttype: '',
					name: '发票',
					opened: true,
					children: [{
						id: 'OUTPUTINVOICE',
						bancktype: '',
						reporttype: 'outputinvoice',
						name: '销项',
						selected: false
					}, {
						id: 'INPUTINVOICE',
						bancktype: '',
						reporttype: 'inputinvoice',
						name: '进项',
						selected: false
					}, {
						id: 'GOODSSPU',
						bancktype: '',
						reporttype: 'goodsspu',
						name: '品类',
						selected: false
					}]
				}, {
					id: 'IMPORT',
					bancktype: '',
					reporttype: 'import',
					name: '导入流水',
					opened: true,
				}, {
					id: '',
					bancktype: '',
					reporttype: '',
					name: '财资流水',
					opened: true,
					children: [{
						id: 'CD',
						bancktype: 'nb',
						reporttype: 'cd',
						name: '现结付(退)款',
						selected: false
					}, {
						id: 'CT',
						bancktype: 'nb',
						reporttype: 'ct',
						name: '退货退款',
						selected: false
					}, {
						id: 'FK',
						bancktype: 'nb',
						reporttype: 'fk',
						name: '月结付款',
						selected: false
					}, {
						id: 'YFK',
						bancktype: 'nb',
						reporttype: 'yfk',
						name: '月结预付款',
						selected: false
					}, {
						id: 'SH',
						bancktype: 'nb',
						reporttype: 'sh',
						name: '售后赔付',
						selected: false
					}, {
						id: 'FY',
						bancktype: 'nb',
						reporttype: 'fy',
						name: '费用支出',
						selected: false
					}, {
						id: 'UT',
						bancktype: 'nb',
						reporttype: 'ut',
						name: '内部转账',
						selected: false
					}, {
						id: 'SK',
						bancktype: 'nb',
						reporttype: 'sk',
						name: '收款',
						selected: false
					}, {
						id: 'TSK',
						bancktype: 'nb',
						reporttype: 'tsk',
						name: '退收款'
					}, {
						id: 'SUPSK',
						bancktype: 'nb',
						reporttype: 'supsk',
						name: '供应商退款'
					}, {
						id: 'OTH',
						bancktype: 'nb',
						reporttype: 'other',
						name: '未分类'
					}]
				}, {
					id: '',
					bancktype: '',
					reporttype: '',
					name: '银联流水',
					opened: true,
					children: [{
						id: 'CD',
						bancktype: 'ums',
						reporttype: 'cd',
						name: '现结退款',
						selected: false
					}, {
						id: 'CT',
						bancktype: 'ums',
						reporttype: 'ct',
						name: '退货退款',
						selected: false
					}, {
						id: 'SH',
						bancktype: 'ums',
						reporttype: 'sh',
						name: '售后赔付',
					}, {
						id: 'SK',
						bancktype: 'ums',
						reporttype: 'sk',
						name: '收款'
					}, {
						id: 'TSK',
						bancktype: 'ums',
						reporttype: 'tsk',
						name: '退收款'
					}, {
						id: 'SUPSK',
						bancktype: 'ums',
						reporttype: 'supsk',
						name: '供应商退款'
					}, {
						id: 'OTH',
						bancktype: 'ums',
						reporttype: 'other',
						name: '未分类'
					}]
				}, {
					id: '',
					bancktype: '',
					reporttype: '',
					name: '形式流水',
					opened: true,
					children: [{
						id: 'FUT',
						bancktype: 'format',
						reporttype: 'fut',
						name: '内部转账',
						selected: false
					}, {
						id: 'FFY',
						bancktype: 'format',
						reporttype: 'ffy',
						name: '费用支出',
						selected: false
					}]
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			changetab(e) {
				console.log(e)
				let target = this.nodestree.find((item) => {
					return item.model.id == e.node
				})
				this.currentnode.data.selected = false
				if (target) {
					target.data.selected = true
					this.itemClick(target.model, target.model)
					this.$nextTick(() => {
						this.$refs.checkReport.$refs.flowcheckreport.commitProxy('query', e.query)
					})
				} else {
					this.emuntree.forEach((item) => {
						let obj = item.children.find((item) => {
							return item.id == e.node
						})
						if (obj) {
							this.itemClick(null, obj)
							this.$nextTick(() => {
								this.$refs.checkReport.$refs.flowcheckreport.commitProxy('query', e.query)
							})
						}
					})
				}


			},
			itemClick(node, item) {
				if (node) {
					this.currentnode = node
					this.nodestree.push(node)
				}
				if (!item.id) {
					return
				}
				console.log(item.reporttype)
				this.reporttypes.push(item.reporttype)
				this.bancktype = item.bancktype
				this.fundtype = item.id
				let currentreporttype = this.reporttype
				this.reporttype = item.reporttype
				if (currentreporttype == item.reporttype) {
					if (this.$refs[this.reporttype + 'Report'].getGrid) {
						this.$refs[this.reporttype + 'Report'].getGrid().reloadData()
					}
					this.$nextTick(() => {
						console.log(this.$refs[this.reporttype + 'Report'], this.reporttype + 'Report')
						this.$refs[this.reporttype + 'Report'].customreload()

					})
				}
				this.reporttype = item.reporttype

			}
		},
		components: {
			// nbReport,
			outputinvoiceReport,
			inputinvoiceReport,
			goodsspuReport,
			cdReport,
			ctReport,
			yfkReport,
			fkReport,
			fyReport,
			futReport,
			ffyReport,
			skReport,
			tskReport,
			supskReport,
			shReport,
			utReport,
			otherReport,
			checkReport,
			importReport,
			checkerrorReport,
			pushdatasearchsaleinvbill,
			pushdataexchangeonline,
			pushdatatradeback,
			relationcustomer,
			relationshop,
			relationwarehouse,
			relationdistributorsupplier,
			sourcebill,
			sourcebilldata,
			VJstree,
		}
	}
</script>